enum SigningMethodType {
  EMAIL = 'EMAIL',
  KAKAO = 'KAKAO',
  IN_PERSON = 'IN_PERSON',
  SECURE_LINK = 'SECURE_LINK',
}

export const selfProceedingSignTypes = [SigningMethodType.EMAIL, SigningMethodType.KAKAO];

export default SigningMethodType;
